import { createAction } from '@reduxjs/toolkit'

export const toggleFullscreen = createAction<{ id: string }>('[TABS] toggleFullscreen')
export const reset = createAction('[TABS] reset')
